import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQuestionsSearchedCount } from '../../API/api';
import { Actions } from "../../Action";
import FileSaver, { saveAs } from "file-saver";
import { useCurrentPng } from "recharts-to-png";
import { jsPDF } from "jspdf"
import {
	ComposedChart,
	Line,
	Area,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	Scatter,
	ResponsiveContainer,
	Label,
	Customized,
	BarChart
} from 'recharts';
import { bindActionCreators } from "redux";
import moment from "moment";
import VizHeader from "../VizHeader/VizHeader";
import { Spin, Dropdown } from "antd";
import * as htmlToImage from 'html-to-image';
import SelectSourceComponentOverview from "../SelectSourceComponentOverview/SelectSourceComponentOverview";
import SelectComponentForMonthsAnsweredByVizerto from '../SelectMonthsDurationCMGraphs/SelectComponentForMonthsAnsweredByVizerto'
import SelectComp from "../../NewComponent/Select/Select";
import ChartToggleComponent from "../../NewComponent/ChartToggleComponent/ChartToggleComponent";
import { toggleChartRegionValues } from "../../utils";
import { ReactComponent as SettingIcon } from "./../../Icons/settings.svg";

export default function ComposedChartComponent(props) {
	const userState = useSelector((state) => state.user);
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	const cmRootReducer = useSelector((state) => state.cmRoot);
	const overViewReducer = useSelector((state) => state.cmOverview);
	const [loading, setLoading] = useState(false);
	const [getKey, setKey] = useState(cmRootReducer.selecetdRoutingValue === 3 ? 'Global' : cmRootReducer.selecetdRoutingValue === 1 ? cmRootReducer.selectedGeoLevel.label : null)
	const [getComposedPng, { ref: composedRef }] = useCurrentPng();
	const [opacity, setOpacity] = useState({
		Suggestion: 1,
		Searched: 1,
		Accuracy: 1,
		getKey: 1,
	});
	const [getRegionData, setRegionData] = React.useState([]);
	const [getRegionKeys, setRegionKeys] = React.useState([]);
	const [activeIndex, setActiveIndexIn] = React.useState(0);
	const [getTooltipPayload, setTooltipPayload] = React.useState([]);
	const [activeKeys, setActiveKeys] = React.useState(['Suggestion', 'Searched', 'Accuracy', 'Global'])
	const [activeKeysRegion, setActiveKeysRegion] = React.useState([])
	const [getLegendName, setLegendName] = React.useState(null)
	const [accuracyExist, setAccuracyExist] = React.useState(false);
	const [activeChartType, setActiveChartType] = React.useState({ id: 1, type: 'line' })
	const [dropdownToggle, setDropdownToggle] = React.useState(false);

	 const dropdownRef = React.useRef(null);
	  
	  const selectRef = React.useRef(null);
	
	  useEffect(() => {
		const handleClickOutside = (event) => {
		  if (!dropdownRef.current) return;
	
		  const isClickInsideDropdown = dropdownRef.current.contains(event.target);
	
		  let isClickInsideSelectDropdown = false;
		  let node = event.target;
		  while (node) {
			if (node.classList && node.classList.contains('ant-select-dropdown')) {
			  isClickInsideSelectDropdown = true;
			  break;
			}
			node = node.parentNode;
		  }
	
		  if (!isClickInsideDropdown && !isClickInsideSelectDropdown) {
			setDropdownToggle(false);
		  }
		};
	
		if (dropdownToggle) {
		  document.addEventListener('mousedown', handleClickOutside);
		} else {
		  document.removeEventListener('mousedown', handleClickOutside);
		}
		return () => {
		  document.removeEventListener('mousedown', handleClickOutside);
		};
	  }, [dropdownToggle]);
	
	  

	const onClickChangeChartType = (value) => {
		setActiveChartType(value)
	}

	const handleMouseEnter = (o) => {
		const { dataKey } = o;
		// setOpacity((prevOpacity) => ({ ...prevOpacity, [dataKey]: 0.25 }));
		setLegendName(dataKey)
	};

	const handleMouseLeave = (o) => {
		const { dataKey } = o;
		setOpacity((prevOpacity) => ({ ...prevOpacity, [dataKey]: 1 }));
		setLegendName(null)
	};

	const handleLegendClick = (e) => {
		const { dataKey } = e;
		const isActive = activeKeys.includes(dataKey);

		// If active, remove it from activeKeys; if not active, add it
		setActiveKeys((prevActiveKeys) =>
			isActive ? prevActiveKeys.filter((key) => key !== dataKey) : [...prevActiveKeys, dataKey]
		);
		// setLegendClicked(!legendClicked)
		// setLegendName(name)
	};

	const handleLegendClickRegion = (e) => {
		const { dataKey } = e;
		const isActive = activeKeysRegion.includes(dataKey);

		// If active, remove it from activeKeys; if not active, add it
		setActiveKeysRegion((prevActiveKeys) =>
			isActive ? prevActiveKeys.filter((key) => key !== dataKey) : [...prevActiveKeys, dataKey]
		);
		// setLegendClicked(!legendClicked)
		// setLegendName(name)

	}




	const dispatch = useDispatch();
	const { getQuestionCountData, getAverageAccuracyCount } = bindActionCreators(Actions, dispatch);
	// const handleAreaDownload = React.useCallback(async () => {
	// 	const png = await getComposedPng();
	// 	if (png) {
	// 		FileSaver.saveAs(png, "answered-by-vizerto.png");
	// 	}
	// }, [getComposedPng]);

	const handleAreaDownload = () => {
		htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[2], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
			.then(function (dataUrl) {
				var link = document.createElement('a');
				link.download = `answered-by-vizerto.png`
				link.href = dataUrl;
				link.click();
			});
	}

	function downloadSvgAsJpeg() {
		htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[2], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
			.then(function (dataUrl) {
				var link = document.createElement('a');
				link.download = 'answered-by-vizerto.jpeg';
				link.href = dataUrl;
				link.click();
			});

	}

	const items = [
		{
			key: "1",
			label: (
				// <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
				//   1st menu item
				// </a>
				<div onClick={() => handleAreaDownload()}>Download as PNG Image</div>
			),
		},
		{
			key: "2",
			label: (
				<div onClick={() => downloadSvgAsJpeg()}>Download as JPEG Image</div>
			),
		},
		{
			key: "4",
			label: (
				<div onClick={() => handleDownloadSVG()}>Download SVG Vector image</div>
			),
		},
	];

	const handleDownloadJPEG = () => {
		const chartContainer = document.getElementsByClassName('recharts-wrapper')[0];
		const chartSvg = chartContainer.querySelector('svg');
		const chartXml = new XMLSerializer().serializeToString(chartSvg);
		const svgBlob = new Blob([chartXml], { type: 'image/jpeg;charset=utf-8' });
		saveAs(svgBlob, 'answered-by-vizerto.jpeg');
	}

	const handleDownloadSVG = () => {
		const chartContainer = document.getElementsByClassName('recharts-wrapper')[2];
		const chartSvg = chartContainer.querySelector('svg');
		const chartXml = new XMLSerializer().serializeToString(chartSvg);
		const svgBlob = new Blob([chartXml], { type: 'image/svg+xml;charset=utf-8' });
		saveAs(svgBlob, 'answered-by-vizerto.svg');
	};

	const CustomTooltip = ({ active, payload, label, data }) => {
		if (active && payload && payload.length > 0 && getTooltipPayload.length > 0) {
			// const additionalData = data[label]
			return (
				// <div className="custom-tooltip" style={{ backgroundColor: '#fff',border:'1px solid #ececec', padding: '3px', fontWeight: 'normal',padding:'5px' }}>
				// 	<p className="label" style={{fontWeight:'bold'}}>{payload[0].payload.date}</p>
				// 	<p className="label">Total Searched:{payload[0].payload.totalSearch}</p>
				// 	<p className="label">Total Suggestion:{payload[0].payload.totalSuggestion}</p>
				// 	{/* <p className="label">Avg Accuracy:{payload[0].payload.totalAccuracy}</p> */}
				// 	{
				// 		payload[0]?.payload.countries.map((ob, ind) => {
				// 			return (
				// 				<>
				// 					<p className="label" key={ind} style={{fontWeight:600}}>
				// 						{ob}:{payload[0].payload[ob]}
				// 					</p>
				// 					<p className="label">Searched:{payload[0].payload.countryWiseSearchCount[ind][ob]}</p>
				// 					<p className="label">Suggestion:{payload[0].payload.countryWiseSuggestionCount[ind][ob]}</p>
				// 				</>
				// 			)
				// 		})
				// 	}
				// </div>
				<div className="custom-tooltip" style={{ backgroundColor: '#fff', border: `1px solid ${getTooltipPayload.length > 0 && getTooltipPayload[0].fill}`, padding: '5px', boxShadow: `0 3px 10px rgb(0 0 0 / 0.3)` }}>
					{
						getTooltipPayload.length > 0 &&
						getTooltipPayload.map((obj, i) => {
							return (
								<>
									<p className="label">{moment(obj.payload.date).format('MMM DD, YYYY')}</p>
									{obj.payload.totalCount > 0 && <p className="label" style={{ fontWeight: 500 }} key={i}>
										Total:{" "}{obj.payload.totalCount.toLocaleString()}
									</p>}
									{obj.value > 0 && <p className="label" style={{ fontWeight: 500 }}>
										{obj.dataKey}:{" "}{obj.value.toLocaleString()}
									</p>}
									{obj.payload.countryWiseSearchCount[obj.dataKey] > 0 && <p className="label" style={{ fontWeight: 500 }}>Searched:{" "}{obj.payload.countryWiseSearchCount[obj.dataKey].toLocaleString()}</p>}
									{obj.payload.countryWiseSuggestionCount[obj.dataKey] > 0 && <p className="label" style={{ fontWeight: 500 }}>Suggestion:{" "}{obj.payload.countryWiseSuggestionCount[obj.dataKey].toLocaleString()}</p>}
								</>
							)
						})
					}
				</div>
			);
		}
		if (active && payload && payload.length > 0 && getTooltipPayload.length === 0) {
			return (
				<p className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '5px', border: '1px solid #ececec' }}>
					<p className="label">{moment(label).format('MMM DD, YYYY')}</p>
				</p>
			)
		}
		return null;
	};

	useEffect(() => {
		const array1 = Object.values(userState.questionAllowedSources).map((label, value) => { return { label: label, value: value } });
		const obj1 = { label: 'All Source', value: array1.map((obj, ind) => { return ind }).toString() }
		array1.unshift(obj1);

		const array2 = Object.entries(userState.questionAllowedSources).map(([label, value]) => { return { value: parseInt(label), name: value } })

		if (cmRootReducer.selecetdRoutingValue !== "") {
			setLoading(true)
			getQuestionsSearchedCount(cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length === 0 ? "" : cmRootReducer.selectedGeoLevel.label, expertOverview.answeredByVizertoDuration.value, expertOverview.source.value, cmRootReducer.selectedDomainIds, overViewReducer.userTypeSelect.value).then((res) => {
				if (res === undefined) return;
				if (res.data.data !== undefined || res.data.success) {
					if (res.data.data[2] === undefined) {
						setAccuracyExist(false)
					}
					if (res.data.data[2] !== undefined) {
						setAccuracyExist(true)
					}
					if (cmRootReducer.selecetdRoutingValue === 1) {
						setKey(cmRootReducer.selectedGeoLevel.label)
						setActiveKeys((prev) => [...prev, cmRootReducer.selectedGeoLevel.label])
					}
					if (cmRootReducer.selecetdRoutingValue === 3) {
						setKey('Global')
					}
					if (cmRootReducer.selecetdRoutingValue === 2) {
						// const formatData = (data) => {
						// 		const searchedCount = data[0];
						// 		const suggestionCount = data[1];
						// 		const accuracyCount = data[2];
						// 		const totalSearchedCount = Object.values(data[0]).map((ob)=>Object.values(ob).reduce((a,b)=>a+b,0));
						// 		console.log(totalSearchedCount,'get total searched count')
						// 		const totalSuggestionCount = Object.values(data[1]).map((ob)=>Object.values(ob).reduce((a,b)=>a+b,0));
						// 		console.log(totalSuggestionCount,'check total suggestions count');
						// 		const countryNames = Object.values(accuracyCount).map((obj,ind)=>Object.keys(obj));
						// 		const countryKeys = countryNames[0];
						// 		const totalAccuracyCount = Object.values(data[2]).map((ob)=> Object.values(ob).reduce((a,b)=>a+b,0)/countryKeys.length);
						// 		console.log(totalAccuracyCount,'check total accuracy count')
						// 		const dates = Object.keys(data[0]);

						// 		setRegionKeys(countryKeys)
						// 		console.log(countryNames,'check country names');
						// 		console.log(dates,'check dates')
						// 		const searchedCountCountry = Object.values(searchedCount)
						// 		console.log(searchedCountCountry,'check count of search')
						// 		let newArr = [];
						// 		dates.filter((ob,ind)=>newArr.push({
						// 			date:ob,
						// 			TotalSearched:totalSearchedCount[ind],
						// 			TotalSuggestionCount:totalSuggestionCount[ind],
						// 			TotalAccuracy:totalAccuracyCount[ind],
						// 			...countryKeys
						// 		}))
						// 		console.log(newArr,'check new array values')
						// 		setRegionData(newArr)
						// }
						// formatData(res.data.data)
						let searchedData = res.data.data[0];
						let suggestionData = res.data.data[1];
						let accuracyData = res.data.data[2];

						const formatData = (sd, sgd, ad) => {
							let dates = Object.keys(sd).sort();
							let newArr = [];
							let countries = Object.keys(sd[dates[0]])
							setRegionKeys(countries)
							setActiveKeysRegion(countries)
							dates.filter((date, index) => {
								let totalCount = 0;
								let totalSearch = 0;
								let totalSuggestion = 0;
								let accurayCount = 0;
								let countryNameSearched = {};
								// let countryWiseSearchCount = [];
								let countryWiseSearchCount = {};
								// let countryWiseSuggestionCount = [];
								let countryWiseSuggestionCount = {};
								newArr.push({ date, countries });
								countries.filter(ct => {
									newArr[index][ct] = sd[date][ct] + sgd[date][ct];
									totalCount = sd[date][ct] + sgd[date][ct] + totalCount;
									totalSearch = sd[date][ct] + totalSearch;
									totalSuggestion = sgd[date][ct] + totalSuggestion;
									// countryNameSearched = {[`Searched${sd[date]}`]:sd[date][ct],[`Suggestion${sgd[date]}`]:sgd[date][ct]}
									// countryWiseSearchCount = Object.entries(sd[date]).map((([name,value])=>{return {[name]:value}}))
									countryWiseSearchCount = sd[date];
									// countryWiseSuggestionCount = Object.entries(sgd[date]).map((([name,value])=>{return {[name]:value}}))
									countryWiseSuggestionCount = sgd[date]
								})
								newArr[index]['totalCount'] = totalCount;
								newArr[index]['totalSearch'] = totalSearch;
								newArr[index]['totalSuggestion'] = totalSuggestion;
								newArr[index]['totalAccuracy'] = accurayCount;
								newArr[index]['countryNameSearched'] = countryNameSearched;
								newArr[index]['countryWiseSearchCount'] = countryWiseSearchCount;
								newArr[index]['countryWiseSuggestionCount'] = countryWiseSuggestionCount;
								// newArr[index]['countryName'] = countryName;
							})
							setRegionData(newArr)
							return newArr;
						}
						formatData(searchedData, suggestionData, accuracyData)
					}
					setLoading(false)
					function getValuesForGeoLevels(val) {
						if (cmRootReducer.selecetdRoutingValue === 1) {
							val = cmRootReducer.selectedGeoLevel.label
							return val;
						}
						if (cmRootReducer.selecetdRoutingValue === 2) {
							let searchedCount = res.data.data[0];
							let suggestionCount = res.data.data[1];
							let accuracyCount = res.data.data[2];
						}
						if (cmRootReducer.selecetdRoutingValue === 3) {
							val = 'Global'
							return val;
						}
					}
					const searchedCount = Object.entries(res.data.data[0]).sort().map(([date, obj]) => ({ date, ...obj }));
					const suggestionCount = Object.entries(res.data.data[1]).sort().map(([date, obj]) => ({ date, ...obj }));
					const accuracyCount = res.data.data[2] === undefined ? [] : Object.entries(res.data.data[2]).sort().map(([date, obj]) => ({ date, ...obj }));
					const suggestionCount2 = res.data.data[3] === undefined ? [] : Object.entries(res.data.data[3]).sort().map(([date, obj]) => ({ date, ...obj }));
					let newCount = [];
					suggestionCount.map((obj, ind) => {
						let innerArray2 = searchedCount.map((ob, i) => { return ob[getValuesForGeoLevels('Global')] });
						let innerArray3 = accuracyCount.length > 0 ? accuracyCount.map((ob, i) => { return ob[getValuesForGeoLevels('Global')] }) : [];
						let innerArray4 = suggestionCount2.length > 0 ? suggestionCount2.map((ob, i) => { return ob[getValuesForGeoLevels('Global')] }) : [];
						let innerArray5 = suggestionCount.map((ob, i) => { return ob[getValuesForGeoLevels('Global')] })

						// let innerArray2 = searchedCount.map((ob, i) => { return ob[getKey] });
						// let innerArray3 = accuracyCount.map((ob, i) => { return ob[getKey] });
						// let innerArray4 = suggestionCount2.map((ob, i) => { return ob[getKey] });

						let avgAccuracyArray = innerArray3.length > 0 && innerArray3.filter((ob) => { if (ob > 0) { return ob } });
						// let obj1 = { date: moment(obj.date).format('MMM DD,YYYY'), Searched: innerArray2[ind], [getKey]: innerArray2[ind] + obj[getValuesForGeoLevels('Global')], Accuracy: innerArray3[ind], Suggestion: innerArray4[ind], AverageAccuracy: (avgAccuracyArray.length > 0) &&(avgAccuracyArray.reduce((a, b) => a + b) / avgAccuracyArray.length).toFixed(1) + `%` }
						// let obj1 = { date: moment(obj.date).format('MMM DD,YYYY'), Searched: innerArray2[ind], [getValuesForGeoLevels('Global')]: innerArray2[ind] , Accuracy: innerArray3[ind], Suggestion: innerArray5[ind], AverageAccuracy: (avgAccuracyArray.length > 0) && (avgAccuracyArray.reduce((a, b) => a + b, 0) / avgAccuracyArray.length).toFixed(1) + `%` }
						let obj1 = {
							date: moment(obj.date).format('MMM DD, YYYY'),
							Searched: innerArray2[ind],
							[getValuesForGeoLevels('Global')]: innerArray2[ind],
							...(innerArray3.length > 0 ? { Accuracy: innerArray3[ind] } : {}),
							// Suggestion: innerArray5[ind],
							...(innerArray5.length > 0 || innerArray5 !== null ? { Suggestion: innerArray5[ind] } : {}),
							// AverageAccuracy: (avgAccuracyArray.length > 0) && (avgAccuracyArray.reduce((a, b) => a + b, 0) / avgAccuracyArray.length).toFixed(1) + `%`
						}
						newCount.push(obj1)
					})
					getQuestionCountData(newCount)
					getAverageAccuracyCount(newCount[0].AverageAccuracy)
				}
			})
		}
	}, [expertOverview.source, expertOverview.answeredByVizertoDuration.value, cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length !== 0 && cmRootReducer.selectedGeoLevel.label, cmRootReducer.selectedDomainIds, overViewReducer.userTypeSelect])

	const renderLabelValue = (val) => {
		if (val === null) {
			return "Last 31 days (UTC Timezone)"
		}
		if (val === '3months') {
			return "Last 3 months"
		}
		if (val === '6months') {
			return "Last 6 months"
		}
		if (val === '12months') {
			return "Last 12 months"
		}
		if (val === '-1months') {
			return "Year-To-Date"
		}
	}

	const CustomizedLegend = (props) => {
		const { payload } = props;
		return (
			<div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px' }}>
				{cmRootReducer.selecetdRoutingValue === 1 && (<span style={{ color: '#7BB4EC', fontWeight: 'bold', padding: '5px' }} >{cmRootReducer.selectedGeoLevel.label}</span>)}
				{cmRootReducer.selecetdRoutingValue === 2 && (<span style={{ color: '#7BB4EC', fontWeight: 'bold', padding: '5px' }}>{cmRootReducer.selectedGeoLevel.label}</span>)}
				{cmRootReducer.selecetdRoutingValue === 3 && (<span style={{ color: '#7BB4EC', padding: '5px' }}>Global</span>)}
				<span style={{ color: '#414A4C', fontWeight: 'bold', padding: '5px' }}>Accuracy{" "}{expertOverview.avgAccuracyCount > `0.0%` ? expertOverview.avgAccuracyCount : '0.0%'}</span>
			</div>
		);
	}

	const handleMouseEnterRegion = (useCallback((data, index) => {
		setActiveIndexIn(index);
		setTooltipPayload(data?.tooltipPayload);
	}, []));

	const handleMouseOutRegion = () => {
		setActiveIndexIn(0)
		setTooltipPayload([])
	}

	const COLORS = [
		'#009bff',
		'#00b8e6',
		'#b85cff',
		'#5e3bff',
		'#f4c900',
		'#ef7928',
		'#00c16e',
		"#7cb5ec",
		"#434348",
		"#90ed7d",
		"#f7a35c",
		"#8085e9",
		"#f15c80",
		"#e4d354",
		"#2b908f",
		"#f45b5b",
		"#91e8e1",
	];

	const CustomizedTooltipForAccuracy = ({ active, payload, label }) => {
		// console.log(payload, 'check payload')
		if (active && payload && payload.length > 0) {
			return (
				<>
					<div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '5px', border: '1px solid #ececec' }}>
						<p className="label">{label}</p>
						{
							payload.map((obj, ind) => {
								if (obj.value > 0) {
									return (
										<>
											<p key={ind} style={{ marginBottom: 5, color: obj.name === 'Accuracy' ? obj.color : obj.fill }}>
												{obj.name}:{" "}{obj.dataKey = 'Accuracy' ? (obj.value > 0 && obj.dataKey === 'Accuracy') ? obj.payload[`Accuracy`] + `%` : obj.value.toLocaleString() : obj.value.toLocaleString()}
											</p>
										</>
									)
								}
							})
						}
						{/* {cmRootReducer.selecetdRoutingValue === 3 && payload[0].payload['Global'] > 0 ?
							<p className="label">Global:{payload[0].payload['Global']}</p>
							: cmRootReducer.selecetdRoutingValue === 1 && payload[0].payload[`${cmRootReducer.selectedGeoLevel.label}`] > 0 ?
							<p className="label">{payload[0].payload[`${cmRootReducer.selectedGeoLevel.label}`]}</p> : null
						} */}
					</div>
				</>
			)
		}
		// if(active && payload && payload.length > 0 && payload[0].value === 0 && payload[1].value  === 0 && payload[2].value === 0 && payload[3].value === 0)
		// {
		// 	console.log(payload,'check payload check')
		// 	return(
		// 		<div className="custom-tooltip">
		// 			<div className="label">{label}</div>
		// 		</div>
		// 	)
		// }
	}
	return (
		<>


			<div style={{ position: 'relative', padding: '10px', backgroundColor: '#fff', borderRadius: '8px' }}>
				<div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '5px' }}>
					<div style={{ width: '30%' }} />
					<div style={{ width: '40%', textAlign: 'center' }}>
						<VizHeader type={4} isBold={true}>Answered by Vizerto</VizHeader>
					</div>
					<div style={{ width: '30%', display: 'flex', paddingRight: '12px', justifyContent: 'flex-end' }}>
						<SettingIcon style={{ fontSize: '24px', cursor: 'pointer', }} onClick={() => setDropdownToggle(!dropdownToggle)} />

					</div>
				</div>



				<Spin spinning={loading}>
					{(cmRootReducer.selecetdRoutingValue === 3 || cmRootReducer.selecetdRoutingValue === 1) && (activeChartType.id === 1) && (
						<ResponsiveContainer width="100%" height={400}>
							<ComposedChart
								width={500}
								height={400}
								data={expertOverview.questionCountData}
								margin={{
									top: 20,
									right: 20,
									bottom: 20,
									left: 20,
								}}
								ref={composedRef}
							>
								<CartesianGrid stroke="#f5f5f5" vertical={false} />
								<XAxis style={{ fontSize: '12px' }} angle={-45} dy={10} dx={2} interval={'equidistantPreserveStart'} dataKey="date" tickFormatter={(value) => moment(value).format('MMM-DD')} scale="band">
									<Label dy={32} fontSize={12} value={renderLabelValue(expertOverview.answeredByVizertoDuration.value)} fontWeight={'bold'} />
								</XAxis>
								<YAxis style={{ fontSize: '12px' }} axisLine={false} tickLine={false} allowDecimals={false}>
									<Label value={"Questions"} angle={-90} fontWeight="bold" dx={-22} />
								</YAxis>
								{accuracyExist && <YAxis axisLine={false} tickLine={false} tickFormatter={(value) => `${value}%`} dataKey="Accuracy" style={{ fontSize: '12px' }} yAxisId="right" orientation="right" domain={[0, 100]}>
									<Label value="Accuracy" angle={90} dx={20} />
								</YAxis>}
								<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={false} content={<CustomizedTooltipForAccuracy />} />
								<Legend wrapperStyle={{ fontSize: '12px', padding: '7px', bottom: -3, fontWeight: 'bold', cursor: 'pointer' }} onClick={handleLegendClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
								<Area isAnimationActive={false} hide={!activeKeys.includes('Suggestion')} type="monotone" dataKey="Suggestion" fill="#b85cff" stroke="#b85cff" opacity={getLegendName === 'Suggestion' || getLegendName === null ? 1 : 0.2} />
								<Bar isAnimationActive={false} hide={!activeKeys.includes('Searched')} dataKey="Searched" barSize={20} fill="#009BFF" opacity={getLegendName === 'Searched' || getLegendName === null ? 1 : 0.2} />
								{accuracyExist && <Line   strokeWidth={1.5} dot={false} isAnimationActive={false} hide={!activeKeys.includes('Accuracy')} type="monotone" dataKey="Accuracy" stroke="#ef7928" fill="#ef7928" yAxisId="right" opacity={getLegendName === 'Accuracy' || getLegendName === null ? 1 : 0.2} />}
								{/* <Line hide={!activeKeys.includes(`${getKey}`)} dataKey={getKey} strokeWidth={2} fill="#1F93D2" strokeOpacity={opacity[`${getKey}`]} /> */}
								<Line dot={false} strokeWidth={1.5} isAnimationActive={false} hide={!activeKeys.includes(`${getKey}`)} dataKey={getKey} stroke="#5e3bff" fill="#5e3bff" opacity={getLegendName === getKey || getLegendName === null ? 1 : 0.2} />
							</ComposedChart>
						</ResponsiveContainer>)
					}
					{
						(cmRootReducer.selecetdRoutingValue === 1 || cmRootReducer.selecetdRoutingValue === 3) && activeChartType.id === 2 && (
							<>
								<ResponsiveContainer width="100%" height={400}>
									<BarChart
										height={400}
										data={expertOverview.questionCountData}
										margin={{
											top: 20,
											right: 20,
											bottom: 20,
											left: 20,
										}}
										ref={composedRef}>
										<CartesianGrid stroke="#f5f5f5" vertical={false} />
										<XAxis style={{ fontSize: '12px' }} angle={-45} dy={10} dx={2} interval={'equidistantPreserveStart'} dataKey="date" tickFormatter={(value) => moment(value).format('MMM-DD')} scale="band">
											<Label dy={32} fontSize={12} value={renderLabelValue(expertOverview.answeredByVizertoDuration.value)} fontWeight={'bold'} />
										</XAxis>
										<YAxis style={{ fontSize: '12px' }} axisLine={false} tickLine={false} allowDecimals={false}>
											<Label value={"Questions"} angle={-90} fontWeight="bold" dx={-22} />
										</YAxis>
										{accuracyExist && <YAxis axisLine={false} tickLine={false} tickFormatter={(value) => `${value}%`} dataKey="Accuracy" style={{ fontSize: '12px' }} yAxisId="right" orientation="right" domain={[0, 100]}>
											<Label value="Accuracy" angle={90} dx={20} />
										</YAxis>}
										<Bar stackId={"a"} dataKey="Searched" fill={'#009bff'} opacity={getLegendName === 'Searched' || getLegendName === null ? 1 : 0.2} hide={!activeKeys.includes('Searched')} />
										<Bar stackId={"a"} dataKey="Suggestion" hide={!activeKeys.includes('Suggestion')} fill={'#b85cff'} opacity={getLegendName === 'Suggestion' || getLegendName === null ? 1 : 0.2} />
										{accuracyExist && <Bar dot={false} stackId="a" isAnimationActive={false} hide={!activeKeys.includes('Accuracy')} type="monotone" dataKey="Accuracy" fill="#ef7928" yAxisId="right" opacity={getLegendName === 'Accuracy' || getLegendName === null ? 1 : 0.2} />}
										<Bar stackId={"a"} dot={false} isAnimationActive={false} hide={!activeKeys.includes(`${getKey}`)} dataKey={getKey} fill="#5e3bff" opacity={getLegendName === getKey || getLegendName === null ? 1 : 0.2} />
										<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={false} content={<CustomizedTooltipForAccuracy />} />
										<Legend wrapperStyle={{ fontSize: '12px', padding: '7px', bottom: -3, fontWeight: 'bold', cursor: 'pointer' }} onClick={handleLegendClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
									</BarChart>
								</ResponsiveContainer>
							</>
						)
					}
					{
						cmRootReducer.selecetdRoutingValue === 2 &&
						(<>
							<ResponsiveContainer width="100%" height={400}>
								<ComposedChart
									width={500}
									height={400}
									data={getRegionData}
									margin={{
										top: 20,
										right: 20,
										bottom: 20,
										left: 20,
										margin: 15
									}}
									ref={composedRef}
								>
									<CartesianGrid stroke="#f5f5f5" vertical={false} />
									<XAxis angle={-45} style={{ fontSize: '11px' }} dy={10} dx={2} dataKey="date" tickFormatter={(value) => moment(value).format('MMM-DD')} scale="band">
										<Label dy={30} fontSize={12} value={renderLabelValue(expertOverview.answeredByVizertoDuration.value)} fontWeight={'bold'} />
									</XAxis>
									<YAxis style={{ fontSize: '12px' }} allowDecimals={false} axisLine={false} tickLine={false}>
										<Label value={"Questions"} fontWeight="bold" angle={-90} dx={-22} />
									</YAxis>
									{/* <YAxis axisLine={false} tickLine={false} tickFormatter={(value) => `${value}%`} dataKey="Accuracy" style={{ fontSize: '12px' }} yAxisId="right" orientation="right" domain={[0, 100]}>
									<Label value="Accuracy" angle={90} dx={20} />
								</YAxis> */}
									<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={false} content={<CustomTooltip />} />
									<Legend onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} wrapperStyle={{ fontSize: '12px', padding: '5px', bottom: -1, fontWeight: 'bold', cursor: 'pointer' }} onClick={handleLegendClickRegion} />
									{/* <Area type="monotone" dataKey="TotalSuggestionCount" fill="#8884d8" stroke="#8884d8" strokeOpacity={opacity.Suggestion} /> */}
									{getRegionKeys.map((ob, ind) =>
										<Bar hide={!activeKeysRegion.includes(ob)} opacity={getLegendName === ob || getLegendName === null ? 1 : 0.2} onMouseOver={handleMouseEnterRegion} onMouseOut={handleMouseOutRegion} stackId={"a"} dataKey={ob} barSize={20} fill={COLORS[ind % COLORS.length]} />
									)
									}
									{/* <Line strokeWidth={2} type="monotone" dataKey="accurayCount" stroke="#414A4C" yAxisId="right" strokeOpacity={opacity.Accuracy} /> */}
									{/* <Scatter dataKey={getKey} fill="#1F93D2" stro
								keOpacity={opacity[`${getKey}`]} /> */}
								</ComposedChart>
							</ResponsiveContainer>
						</>)
					}
				</Spin>

				{dropdownToggle && (
					<div 
					ref={dropdownRef}
					style={{
						position: 'absolute',
						top: '50px',
						right: '10px',
						width: '240px',
						backgroundColor: '#fff',
						padding: '12px',
						border: '1px solid #ccc',
						borderRadius: '8px',
						boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
						zIndex: 10
					}}>
						<div style={{ textAlign: 'end' }}>
							<i
								onClick={() => setDropdownToggle(false)}
								className="fa fa-close"
								style={{ fontSize: '18px', cursor: 'pointer' }}
							/>
						</div>
						<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							{/* <i className="fa fa-gear" style={{ fontSize: '24px', cursor: 'pointer' }} onClick={() => setDropdownToggle(false)} /> */}
						</div>
						<div style={{ paddingBottom: '5px' }}>
							<div ref={selectRef}>
							<SelectSourceComponentOverview />
							</div>
						</div>
						<div style={{ paddingBottom: '5px' }}>
							<div ref={selectRef}>
							<SelectComponentForMonthsAnsweredByVizerto />
							</div>
						</div>

						{toggleChartRegionValues(cmRootReducer.selecetdRoutingValue) && <div style={{ width: '100%', marginLeft: '4px', paddingBottom: '7px', textAlign: 'end' }}>
							{/* <SelectComp val={activeChartType} width={'100%'} onChangeFunc={onClickChangeChartType} options={[{label:'Composed Chart',value:1},{label:'Bar Graph',value:2}]} />	 */}
							<ChartToggleComponent fontSize={'24px'} type={'line'} value={activeChartType} onClickFunction={() => onClickChangeChartType({ id: 1, type: 'line' })} />
							&nbsp;&nbsp;&nbsp;
							<ChartToggleComponent fontSize={'24px'} value={activeChartType} onClickFunction={() => onClickChangeChartType({ id: 2, type: 'bar' })} type='bar' />
						</div>}
						<div style={{ textAlign: 'end', paddingTop: '15px', paddingBottom: '5px' }}>
							<span style={{ color: '#5c667b', fontSize: '14px', fontFamily: 'Inter' }}>Download PNG</span>{" "}
							<span onClick={() => handleAreaDownload()} style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }}><i className="fa fa-download" /></span>
						</div>
						<div style={{ textAlign: 'end', paddingTop: '15px', paddingBottom: '5px' }}>
							<span style={{ color: '#5c667b', fontSize: '14px', fontFamily: 'Inter' }}>Download JPEG</span>{" "}
							<span onClick={() => downloadSvgAsJpeg()} style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }}><i className="fa fa-download" /></span>
						</div>
						<div style={{ textAlign: 'end', paddingTop: '15px', paddingBottom: '5px' }}>
							<span style={{ color: '#5c667b', fontSize: '14px', fontFamily: 'Inter' }}>Download SVG</span>{" "}
							<span onClick={() => handleDownloadSVG()} style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }}><i className="fa fa-download" /></span>
						</div>
					</div>
				)}
			</div>
		</>
	)
}